import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/categoria';

export default {

  /*

   */

  tiposDocumentos: Object.freeze(Utils.orderBy([
    { id: 'DINHEIRO', nome: "Dinheiro"},
    { id: 'PIX', nome: "PIX"},
    { id: 'DEBITO', nome: 'Cartão de Débito' },
    { id: 'CREDITO', nome: 'Cartão de Crédito' },
    { id: 'CHEQUE', nome: "Cheque"},
    { id: 'BOLETO', nome: "Boleto"},
    { id: 'DEPOSITO', nome: "Depósito"},
    { id: 'RECIBO', nome: "Recibo"},
    { id: 'NOTA_FISCAL', nome: "Nota Fiscal"},
    { id: 'COMPROVANTE', nome: "Comprovante"},
    { id: 'CONTRACHEQUE', nome: "Contracheque"},
    { id: 'CUPOM_FISCAL', nome: "Cupom Fiscal"},
    { id: 'DOCUMENTO_FISCAL', nome: "Documento Fiscal"},
    { id: 'FATURA', nome: "Fatura"},
    { id: 'GUIA', nome: "Guia de Recolhimento"},
    { id: 'CODIGO_IDENTIFICADOR', nome: "Código Identificador"},
  ], 'nome')),

  categoriasCnj: Object.freeze(Utils.orderBy([
    { id: 'DESPESAS_FUNCIONAMENTO', nome: "Despesas de Funcionamento" },
    { id: 'DESPESAS_LEGAIS', nome: "Despesas Legais" },
    { id: 'OUTRAS_DESPESAS', nome: "Outras Despesas" },
  ], 'nome')),

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async getAllSimpleList() {
    return Http.get(`${path}/all-simple`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getSimpleListIds(ids){
    return Http.post(`${path}/simple`, ids);
  },

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async getListaCodContabil(){
    return Http.get(`${path}/get-lista-cod-contabil`);
  },

  async getCategoriasTJ(tipo){
    return Http.get(`${path}/categorias-tj?tipo=${tipo}`);
  },

}
